import styled from 'styled-components';
import {BLACK, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';

export const emptyContainer = styled.div`
    ${dFlexColumnCenter}
    padding-block: 60px;
    padding-inline: 20px;
    text-align: center;
    min-height: 500px;
    width: 100%;
    
    ${mobileMedia} {
        padding-block: 40px;
        padding-inline: 15px;
        min-height: 400px;
    }
`;

export const emptyImage = styled.img`
    max-width: 220px;
    width: 100%;
    height: auto;
    margin-block-end: 30px;
    
    ${mobileMedia} {
        max-width: 180px;
        margin-block-end: 20px;
    }
`;

export const emptyText = styled.p`
    font-size: 16px;
    color: ${BLACK};
    font-weight: bold;
    line-height: 1.5;
    max-width: 300px;
    text-align: center;
    margin: 0 auto;
    
    ${mobileMedia} {
        font-size: 14px;
        max-width: 250px;
        line-height: 1.4;
    }
`;
